module.exports = __webpack_public_path__ + "img/2x.ec6e864.jpg";